import Vue from 'vue';
import InputFacade from 'vue-input-facade';
import Toasted from 'vue-toasted';
import VueJWT from 'vuejs-jwt';
import VueSocialSharing from 'vue-social-sharing';
import Ripple from 'vue-material-design-ripple';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import VRipple from 'vue-ripple-directive';
import App from './App.vue';
import './registerServiceWorker';
import responsive from './assets/responsive.scss';
import maincss from './assets/main.scss';
import defStyle from './assets/def.scss';
import router from './router';
import store from './store';

Vue.directive('ripple', VRipple);
Vue.use(InputFacade);
// new toast
Vue.use(VueSocialSharing);
Vue.config.productionTip = false;
Vue.use(LottieAnimation);
Vue.use(Toasted, {
  iconPack: 'mdi',
  icon: {
    name: 'keyboard_arrow_down',
    after: true,
  },
  theme: 'bubble',
  position: 'bottom-center',
  duration: 3500,
});
Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'تاریخ و ساعت شروع کلاس',
    altFormat: 'dddd jDD jMMMM jYYYY ساعت HH:mm',
    format: 'YYYY-MM-DDT',
    color: 'var(--primary)',
    autoSubmit: false,
  },
});
Vue.use(VueJWT);
Vue.directive('ripple', Ripple);
new Vue({
  router,
  store,
  defStyle,
  responsive,
  maincss,
  render: (h) => h(App),
}).$mount('#app');
